<div class="vtr-material-menu">
	<nav class="navbar navbar-expand-xl pr-0 menu-navbar">
		<div class="navbar-brand h-100 p-0 border-0 border-radius-0 text-center" id="vantage_image_L" role="img">			
			<svg xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 256 256">
				<defs>
					<style>
						.a {
							fill: #e1140a;
						}

						.b {
							fill: #fff;
						}

						.c {
							fill: #590804;
						}
					</style>
				</defs>
				<rect class="a"
					width="256"
					height="256" />
				<polygon class="b"
					points="197.43 166.56 119.26 166.56 119.26 35.43 84.4 35.43 84.4 198.14 197.43 198.14 197.43 166.56" />
				<polygon class="c"
					points="54.6 215.2 84.4 198.14 197.43 198.14 54.6 215.2" />
				<polygon class="c"
					points="54.6 215.2 84.4 198.14 84.4 41.78 54.6 215.2" />
			</svg>
		</div>
		<div class="navbar-text ml-2 mr-auto clearfix">		
			<span>
				<div class="text-left device-type">
					<span *ngIf="!machineFamilyName">&nbsp;</span>
					<span role="text"
						*ngIf="machineFamilyName" id="menu-main-text-machineFamilyName"
						[innerHTML]="machineFamilyName">
					</span>
					<span *ngIf="deviceService.showWarranty && machineFamilyName"
						class="pl-2">
						<vtr-ui-header-warranty [pageParent]="'NavBar'">
						</vtr-ui-header-warranty>
					</span>
				</div>
			</span>
		</div>
		<ng-container *ngIf="!loadMenuItem?.hideMenus && (loadMenuItem?.firstRunDate?.length || !deviceService.isShellAvailable)">
			<button mat-icon-button
				[matMenuTriggerFor]="hamburgerDropdownMenu?.matMenu"
				id="menu-main-btn-navbar-toggler"
				class="position-relative w-auto h-auto mr-1 py-1 px-3 rounded-0 text-center navbar-toggler line-height-normal"
				aria-label="menu-main-btn-navbar-toggler"
				aria-haspopup="true"
				aria-expanded="false"
				(click)="toggleMenu($event)"
				(keydown.enter)="toggleMenu($event)">
				<span class="navbar-toggler-icon">
					<fa-icon [icon]="['fas', 'bars']"></fa-icon>
				</span>			
			</button>
			<vtr-material-hamburger-menu
				#hamburgerDropdownMenu="materialHamburgerMenuComponent"
				[items]="items"
				[currentRoutePath]="currentRoutePath">
			</vtr-material-hamburger-menu>
		</ng-container>
		<div *ngIf="!loadMenuItem?.hideMenus && (loadMenuItem?.firstRunDate?.length || !deviceService.isShellAvailable)"
			class="h-100 flex-1 menu-container"
			#menuTarget>
			<ul class="h-100 ml-auto list-unstyled row justify-content-end">
				<ng-container *ngFor="let item of items; trackBy:identify" class="h-100">
					<li class="h-100" *ngIf="item && item.hide===false && (!item.subitems || item.subitems.length === 0)  && item.id !== 'app-search'">
						<button mat-button
							*ngIf="item.label | translate"
							class="h-100 d-flex align-items-center m-0 px-3 color-light border-radius-0 min-width-0 menu-item {{item.id}}"
							[ngClass]="{'beta-item':item.beta}"							
							id="menu-main-nav-lnk-{{item.id}}"
							attr.new-tip-id="new-tip-{{item.id}}"						
							routerLink="/{{item.path}}"
							routerLinkActive="active"
							href="javascript:void(0)"							
							(keydown.enter)="menuItemKeyDown(item.path)"
							>
							{{item.label | translate}}
							<span *ngIf="item.beta"
								class="beta">Beta</span>
						</button>
					</li>
					<li class="h-100" *ngIf="item && item.hide===false && item.subitems && item.subitems.length > 0 && item.id !== 'app-search'">
						<button mat-button	
							vtrMenuHover						
							#menuTrigger="menuHoverDirective"
							[menuHoverTriggerFor]="materialMenuDropdown?.matMenu"
							class="h-100 d-flex align-items-center m-0 px-3 color-light border-radius-0 min-width-0 menu-item {{item.id}}"
							[ngClass]="{'beta-item': item.beta, 'actived': updateActiveItem(item.id)}"
							role="menu"						
							id="menu-main-nav-lnk-dropdown-toggle-{{item.id}}"
							attr.aria-label="{{item.id}}"
							attr.new-tip-id="new-tip-{{item.id}}"
							aria-haspopup="true"
							aria-expanded="false"						
							routerLink="/{{item.firstVisibleChildLink}}"
							routerLinkActive="active"
							href="javascript:void(0)"							
							(keydown.enter)="menuItemKeyDown(item.firstVisibleChildLink)"
							
							(pointerenter)="handlePointerEnter(menuTrigger, $event)"
							(pointerleave)="clearCloseAllOtherMatMenu()"
							(focus)="closeAllOtherMatMenu(menuTrigger)">
							<span [innerHTML]="item.label | translate"></span>							
						</button>
						<vtr-material-menu-dropdown
							#materialMenuDropdown="materialMenuDropdownComponent"
							[dropdownMenu]="item"
							[parentPath]="item.path"
							[parentId]="item.id"
							class="d-inline-block align-top">
						</vtr-material-menu-dropdown>
					</li>
				
				</ng-container>
				<div class="d-none">
					<img *ngFor="let i of preloadImages"
						[src]="i"
						alt="">
				</div>
			</ul>
		</div>
	</nav>
</div>